import getNodeType from "./getNodeType.js";

export default (node, availableNodes) => {
    if(typeof node !== "object" || typeof availableNodes !== "object") {
        console.error("Cant check can it be copied");
        return;
    }

    return (getNodeType(node, availableNodes).canBeCopied ?? true);
}